var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{class:['search-btn', _vm.isOpen ? 'search-btn-close' : 'primary'],attrs:{"aria-label":"search button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{class:`icon-${!_vm.isOpen ? 'search' : 'close'}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }